export const headers = [
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Controlador', field: 'controller', sortable: false },
  { name: 'Método', field: 'method', sortable: false },
  { name: 'Ícone', field: 'icon', sortable: false },
  { name: 'Ação', field: 'action', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]
